import M from '@superstructure.net/m';
import C from '@superstructure.net/c';

/**
 * Video
 */

class Video extends M {
    constructor(mediaQuery) {
        super(mediaQuery);
    }

    bindEvents() {
        this.video.addEventListener('canplay', () => {
            console.log('video', this.video);
            this.video
                .play()
                .then(() => {})
                .catch(() => {});
        });
    }

    onInit() {
        console.log('Video.onInit()');

        this.events = new C();

        this.video = document.querySelector('[data-Video-role~="video"]');
        this.wrapper = document.querySelector('[data-Video-role~="wrapper"]');
        if (!this.video || !this.wrapper) return;

        this.bindEvents();
    }

    onResize(viewport, isUIResize) {
        console.log('Video.onResize()');
    }

    onDestroy() {
        console.log('Video.onDestroy()');

        this.events.off();
    }
}

export { Video };
